import type { Container } from "inversify";
import ApiService from "@/src/application/services/api-service";
import { AuthApi, UserApi } from "@generated/n3-backend-api";
import { CompositeDataV2ControllerApi } from "@generated/n3-backend-api/n3-backend-open-api-gen/composite-data-v2-controller-api";
import { DeviceLinkClaimV2ControllerApi } from "@generated/n3-backend-api/n3-backend-open-api-gen/device-link-claim-v2-controller-api";
import { DeviceV2ControllerApi } from "@generated/n3-backend-api/n3-backend-open-api-gen/device-v2-controller-api";
import { MeasurementV2ControllerApi } from "@generated/n3-backend-api/n3-backend-open-api-gen/measurement-v2-controller-api";
import { NotificationV2ControllerApi } from "@generated/n3-backend-api/n3-backend-open-api-gen/notification-v2-controller-api";

export function registerN3Backend(container: Container) {
  container
    .bind<UserApi>(UserApi)
    .toDynamicValue((context) => {
      const axiosInstance = context.get(ApiService).getAxiosInstance();
      return new UserApi(undefined, undefined, axiosInstance);
    })
    .inSingletonScope();

  container
    .bind<DeviceV2ControllerApi>(DeviceV2ControllerApi)
    .toDynamicValue((context) => {
      const axiosInstance = context.get(ApiService).getAxiosInstance();
      return new DeviceV2ControllerApi(undefined, undefined, axiosInstance);
    })
    .inSingletonScope();

  container
    .bind<DeviceLinkClaimV2ControllerApi>(DeviceLinkClaimV2ControllerApi)
    .toDynamicValue((context) => {
      const axiosInstance = context.get(ApiService).getAxiosInstance();
      return new DeviceLinkClaimV2ControllerApi(undefined, undefined, axiosInstance);
    })
    .inSingletonScope();

  container
    .bind<MeasurementV2ControllerApi>(MeasurementV2ControllerApi)
    .toDynamicValue((context) => {
      const axiosInstance = context.get(ApiService).getAxiosInstance();
      return new MeasurementV2ControllerApi(undefined, undefined, axiosInstance);
    })
    .inSingletonScope();
  container
    .bind<AuthApi>(AuthApi)
    .toDynamicValue((context) => {
      const axiosInstance = context.get(ApiService).getAxiosInstance();
      return new AuthApi(undefined, undefined, axiosInstance);
    })
    .inSingletonScope();

  container
    .bind<CompositeDataV2ControllerApi>(CompositeDataV2ControllerApi)
    .toDynamicValue((context) => {
      const axiosInstance = context.get(ApiService).getAxiosInstance();
      return new CompositeDataV2ControllerApi(undefined, undefined, axiosInstance);
    })
    .inSingletonScope();

  container
    .bind<NotificationV2ControllerApi>(NotificationV2ControllerApi)
    .toDynamicValue((context) => {
      const axiosInstance = context.get(ApiService).getAxiosInstance();
      return new NotificationV2ControllerApi(undefined, undefined, axiosInstance);
    })
    .inSingletonScope();
}
